<template>
    <div>
        <div class="col-md-12 mt-3 pl-3 none_gauge" v-if="!this.is_pay">

            <iframe :src="iframeUrl" ref="iframe" frameborder="0" class="w-100 h-100"></iframe>


        </div>
        <div class="col-md-12 mt-3 pl-3 none_gauge" v-if="this.is_pay">
            <div class="charge_hint nano w-100 h-100">
                <div class="centre_content nano-content">
                    <div class="card text-center p-3 pb-0">
                        <div class="card-body p-0 mycard">
                            <!--<NoPay :obj="detailes"></NoPay>-->
                            <h5 class="mt-3 mb-3 ">
                                <img src="../../../assets/images/silkRoadBase/member.png" class="mr-2" />
                                VIP exclusive
                            </h5>
                            <h4 class="f20 fn600">Paid subscription</h4>
                            <p class="card-text f15 text-secondary mt-3 mb-3">Buy a VIP membership to enjoy exclusive service of Xinhua Silk Road</p>
                            <a href="/db#/accountSettings/menberCenter" class="btn btn-warning mt-3 text-white">Buy now</a>
                            <p class="mt-5 mb-5">More VIP privileges</p>
                            <div class="d-flex row justify-content-around m-0">
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/56878730129766812.png">
                                        <h5 class="card-title mt-3 mb-3">Analyst service</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">180 overseas branches of Xinhua News Agency, and chief reporters' observations and interaction with them</h6>
                                    </div>
                                </div>
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/41408370476170076.png">
                                        <h5 class="card-title mt-3 mb-3">Consulting service</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">Research trends and achievements of more than 100 top think tanks and consulting institutions in the world</h6>
                                    </div>
                                </div>
                                <div class="card col-md-4 col-12 p-0">
                                    <div class="card-body">
                                        <img src="../../../assets/images/silkRoadBase/507574572099684577.png">
                                        <h5 class="card-title mt-3 mb-3">Overseas activities service</h5>
                                        <h6 class="card-subtitle mb-2 text-muted">Latest information inquiry and release of investment projects home and abroad</h6>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>
    export default({
        name: 'project',
        data: function() {
            return {
                iframeUrl:"https://ifs.imsilkroad.com/index?lang=en_US",
                is_pay:true
            }

        },
        created: function() {
            var self = this;
            // 检查用户权限
            this.$axios.post('/api/pc/checkpagepermission', {'type':'project'}).then(function (response) {
                if (response.data.state) {
                    if (!response.data.data.is_pay) {
                        self.is_pay = false;
                        self.iframeUrl= self.$route.query.url?self.$route.query.url:"https://ifs.imsilkroad.com/index?lang=en_US";
                    }
                }
            })

        },
        mounted() {
            this.load();
        },

    })
</script>
